import {
    emptySource,
    filterRows,
    sliceWindow,
    sortRows,
    TableDataRow,
    TableSource,
    TableWindow,
    TableData,
} from 'sdi/components/table2';
import { queryK, query } from 'sdi/shape';
import { findIssue, getType, getGlobalInfoFilteredIssues } from '../queries/qa';

import * as debug from 'debug';

import { Issue } from '../remote';
import tr from 'sdi/locale';
import { messageKeyFromNullable } from '../events/app';
import { fromNullable } from 'fp-ts/lib/Option';
import { renderOsmIdCell } from '../components/table/cell';
const logger = debug('sdi:index');

export const getUsers = () => query('data/users');

export const tableQuery = queryK('component/table');
export const getSelectedIssueIds = queryK('qa/issues/select');

export const getSelectedIssues = () => {
    const issues: Issue[] = [];
    getSelectedIssueIds().map(id => findIssue(id).map(i => issues.push(i)));
    return issues;
};

type TableFieldType =
    | 'string'
    | 'number'
    | 'boolean'
    | 'date'
    | 'datetime'
    //| 'node'
    | 'term';
type TableField = [string, TableFieldType];
//type TableField = [string, TableDataCell];

const getFields = (): TableField[] => [
    ['ID', 'number'],
    [tr.qa('date'), 'datetime'],
    [tr.qa('criticality'), 'string'],
    [tr.qa('status'), 'string'],
    [tr.qa('OSMObject'), 'string'],
    [tr.qa('description'), 'string'],
    [tr.qa('origin'), 'string'],
    [tr.qa('contributor'), 'string'],
    ['ID OSM', 'term'], //TODO changed from node
    [tr.qa('version'), 'string'],
];

const rowFromIssue = (issue: Issue): TableDataRow => {
    return getType(issue.issue_type)
        .map(t => ({
            from: issue.id,
            cells: [
                issue.id,
                Date.parse(
                    fromNullable(issue.osm_timestamp).getOrElse(issue.timestamp)
                ),
                tr.qa(messageKeyFromNullable(issue.criticity)),
                tr.qa(messageKeyFromNullable(issue.status)),
                //renderStationCell(issue),
                fromNullable(t.osm_object)
                    .map<string>(o => o)
                    .getOrElse('-'),
                t.short_description,
                tr.qa(messageKeyFromNullable(issue.origin)),
                `${issue.osm_user}`,
                renderOsmIdCell(issue),
                fromNullable(issue.osm_version).getOrElse(1),
            ],
        }))
        .getOrElse({
            from: issue.id,
            cells: [
                issue.id,
                Date.parse(issue.timestamp),
                '~no type found',
                messageKeyFromNullable(issue.status),
                '~no type found',
                '~no type found',
                '~no origin found',
                '~contributor not found',
                renderOsmIdCell(issue),
                fromNullable(issue.osm_version).getOrElse(1),
            ],
        });
};

export const getFilteredAndSortedRows = (issues: Issue[]): TableDataRow[] => {
    // const filterLinked = getSelectedLinkedGroup().isSome()
    //     ? getSelectedLinkedGroup().map(lg => lg.issues)
    //     : some([]);
    // const rawRows = filterLinked //TODO
    //     .map(fl => issues.filter(i => fl.indexOf(i.id) >= 0))
    //     .getOrElse(issues)
    //     .map(rowFromIssue);
    const rawRows = issues.map(rowFromIssue);
    const { filters, sort } = query('component/table');
    const sorter = sort
        .map(s => sortRows(s.col, s.direction, getFields()))
        .getOrElse((data: TableDataRow[]) => data);

    const filter = filterRows(filters);
    const filteredRows = filter(rawRows);
    return sorter(filteredRows);
};

export const getTableTitle = () => fromNullable(query('component/table/title'));

const getTableData = (issues: Issue[], w: TableWindow): TableData => {
    const slicer = sliceWindow(w);
    const sortedRows = getFilteredAndSortedRows(issues);
    const windowedRows = slicer(sortedRows);
    return {
        rows: windowedRows,
        total: sortedRows.length,
        filteredCount: 0,
    };
};

export const layerSource = (): TableSource =>
    getGlobalInfoFilteredIssues()
        .map(issues => ({
            data: (w: TableWindow) => getTableData(issues, w),
            fields: getFields(),
        }))
        .getOrElse(emptySource());

logger('loaded');
